import { matchPath, useHistory, useLocation } from 'routerCompat';

export default function useRouterCompat(matchProps?: any) {
  const history = useHistory();
  const location = useLocation();
  const match = matchProps ? matchPath(location.pathname, matchProps) : null;

  return {
    history,
    location,
    match,
  };
}
